import baseAPI from '@/api';
import { ReferralVoucher } from '@/models/referral-voucher';
import { QueryFunctionContext } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { UseReferralVoucherMainQueryKey } from './props';

export async function fetchReferralVoucherMain({
  queryKey,
}: QueryFunctionContext<UseReferralVoucherMainQueryKey>): Promise<ReferralVoucher> {
  const response: AxiosResponse<ReferralVoucher> =
    await baseAPI.get<ReferralVoucher>('/referral-vouchers/main');

  return response.data;
}
